import { useNavigate } from "react-router-dom";

const BusinessNoWaiver = ({ archived = false }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center text-center py-20">
      <h2 className="text-darkLighted font-light text-[28px] mb-2">
        {archived ? "No archived waivers" : "No waivers yet"}
      </h2>

      <p className="text-foreground mb-6">
        {archived
          ? "There are no archived waivers to display"
          : "Create a waiver to begin collecting signatures"}
      </p>

      <button
        onClick={() => navigate("/business/waiverbuilder/create")}
        className="inline-flex items-center gap-2 bg-highlited text-black font-medium py-3 px-8 rounded-full hover:bg-[#D5AA00] transition"
      >
        Create First Waiver →
      </button>

      {/* Illustration */}
      <div className="mt-12">
        <img
          src="/images/no-waiver.svg"
          alt="No waivers"
          className="max-w-sm mx-auto"
        />
      </div>
    </div>
  );
};

export default BusinessNoWaiver;